<input type="checkbox" id="active1" />
<label for="active1" class="menu-btn"><span></span></label>
<label for="active1" class="close"></label>
<div *ngIf="user" class="dashboard">
  <h3 style="display: block">Hi, {{ user.nom }}</h3>
  <br />
  <p style="display: block !important">{{ user.titre }}</p>
  <br />
  <ul class="nav">
    <li class="nav-item" routerLink="/home/profile" routerLinkActive="active">
      <i
        class="fa-solid fa-user-group"
        style="
          color: #79D1EE;
          vertical-align: -50%;
          margin-right: 15px;
          font-size: 25px;
        "
      ></i>
      <a href="/home/profile">Profile</a>
    </li>
    <li class="nav-item" routerLinkActive="active" href="/home/calendar">
      <i
        class="fa-regular fa-calendar"
        style="
          color: #79D1EE;
          vertical-align: -50%;
          margin-right: 15px;
          font-size: 25px;
        "
      ></i>
      <a href="/home/calendar">Calendar</a>
    </li>
    <li [hidden]="hidealumni" class="nav-item" routerLinkActive="active" href="/home/gestion-alumni">
      <i
      class="fa-sharp fa-regular fa-file-lines"
        style="
          color: #79D1EE;
          vertical-align: -50%;
          margin-right: 10px;
          font-size: 25px;
        "
      ></i>
      <a [hidden]="hidealumni" href="/home/gestion-alumni">Alumni</a>
    </li>
    <li
      class="nav-item"
      routerLinkActive="active"
      routerLink="/home/posts"
    >
      <i
        class="fa-sharp fa-regular fa-file-lines"
        style="
          color: #79D1EE;
          vertical-align: -50%;
          margin-right: 10px;
          font-size: 25px;
        "
      ></i>

      <a href="/home/posts">Marketplace</a>
    </li>
    <li class="nav-item" routerLinkActive="active" href="/home/score">
      <i
        class="fa-solid fa-file-pen"
        style="
          color: #79D1EE;
          vertical-align: -50%;
          margin-right: 15px;
          font-size: 25px;
        "
      ></i
      ><a href="/home/score">Score</a>
    </li>
    <li
      class="nav-item"
      routerLinkActive="active"
      routerLink="/home/opportunities"
    >
      <i
        class="fa-regular fa-newspaper"
        style="
          color: #79D1EE;
          vertical-align: -50%;
          margin-right: 10px;
          font-size: 25px;
        "
      ></i
      ><a href="/home/opportunities">Opportunities</a>
    </li>

    <li [hidden]="hideuniversities" class="nav-item" 
    href="home/universities" routerLinkActive="active">
      <i class="fa-solid fa-building-columns" style="color: #79D1EE;vertical-align: -50%;margin-right: 15px;font-size: 25px;"></i>
      <a href="home/universities">Universities</a>
    </li>

    <li [hidden]="hideclubs" class="nav-item" 
    href="home/clubs" routerLinkActive="active">
      <i class="fa-solid fa-building-columns" style="color: #79D1EE;vertical-align: -50%;margin-right: 15px;font-size: 25px;"></i>
      <a href="home/clubs">Clubs</a>
    </li>
    <li class="nav-item" routerLink="/home/events" routerLinkActive="active">
      <i
        class="fa-solid fa-building-columns"
        style="
          color: #79D1EE;
          vertical-align: -50%;
          margin-right: 15px;
          font-size: 25px;
        "
      ></i>
      <a href="/home/events">Events</a>
    </li>

    <li
      class="nav-item"
      href="home/profile/settings"
      routerLinkActive="active"
    >
      <i
        class="fa-solid fa-gear"
        style="
          color: #79D1EE;
          vertical-align: -50%;
          margin-right: 15px;
          font-size: 25px;
        "
      ></i>
      <a href="home/profile/settings">Settings</a>
    </li>
  </ul>
  <hr />
  <br />
  <img
    src="assets/images/studenty-logo.png"
    style="
      width: 250px;
      height: 350px;
      margin-left: -10px;
      border: 2px ;
      display: block;
    "
    alt="studenty logo"
  />
</div>

<nav class="wrapper">
  <h3>Hi,</h3>
  <ul>
    <li href="/home/profile" routerLinkActive="active">
      <a href="/home/profile">
        <i class="fa fa-2x"
          ><fa-icon
            style="margin-left: 10px; color: #79D1EE"
            [icon]="faUser"
          ></fa-icon
        ></i>
        <span class="nav-text">
          <a href="/home/profile"> Profile</a>
        </span>
      </a>
    </li>
    <li
      class="has-subnav"
      routerLinkActive="active"
      routerLink="/home/calendar"
    >
      <a href="/home/calendar">
        <i class="fa fa-2x"
          ><fa-icon style="color: #79D1EE" [icon]="faCalendar"></fa-icon
        ></i>
        <span class="nav-text">
          <a href="/home/calendar"> Calendar</a>
        </span>
      </a>
    </li>
    <li class="has-subnav">
      <a href="/home/gestion-alumni">
        <i class="fa fa-2x"
          ><fa-icon style="color: #79D1EE" [icon]="faDoc"></fa-icon>
        </i>
        <span class="nav-text">
          <a href="/home/gestion-alumni">Alumni</a>
        </span>
      </a>
    </li>
    <li class="has-subnav">
      <a href="/home/posts">
        <i class="fa fa-2x"
          ><fa-icon style="color: #79D1EE" [icon]="faDoc"></fa-icon>
        </i>
        <span class="nav-text">
          <a href="/home/posts">Marketplace</a>
        </span>
      </a>
    </li>
    <li class="has-subnav" routerLinkActive="active" routerLink="/home/score">
      <a href="/home/score">
        <i class="fa fa-2x"
          ><fa-icon style="color: #79D1EE" [icon]="faBlog"></fa-icon>
        </i>
        <span class="nav-text">
          <a href="/home/score">score</a>
        </span>
      </a>
    </li>
    <li routerLinkActive="active" routerLink="/home/opportunities">
      <a href="/home/opportunities">
        <i class="fa fa-2x"
          ><fa-icon style="color: #79D1EE" [icon]="faInterested"></fa-icon>
        </i>
        <span class="nav-text">
          <a href="/home/opportunities">opportunities</a>
        </span>
      </a>
    </li>
    <li
      [hidden]="hideuniversities"
      href="/home/events"
      routerLinkActive="active"
    >
      <a href="/home/events">
        <i class="fa fa-2x"
          ><fa-icon style="color: #79D1EE" [icon]="faUniversity"></fa-icon>
        </i>
        <span class="nav-text">
          <a href="/home/events">Events</a>
        </span>
      </a>
    </li>

    <li  [hidden]="hideuniversities" routerLink="home/universities" routerLinkActive="active">
      <a href="#">
          <i class="fa fa-2x"><fa-icon style="color: #79D1EE;" [icon]="faUniversity"></fa-icon>
            </i>
          <span class="nav-text">
            <a href="home/universities">Universities</a>
          </span>
      </a>
  </li>

  <li  [hidden]="hideclubs" routerLink="home/clubs" routerLinkActive="active">
    <a href="#">
        <i class="fa fa-2x"><fa-icon style="color: #79D1EE;" [icon]="faUniversity"></fa-icon>
          </i>
        <span class="nav-text">
          <a href="home/clubs">Clubs</a>
        </span>
    </a>
</li>

    <li routerLink="home/profile/settings" routerLinkActive="active">
      <a href="#">
        <i class="fa fa-2x"
          ><fa-icon style="color: #79D1EE" [icon]="faCog"></fa-icon>
        </i>
        <span class="nav-text">
          <a href="home/profile/settings">Settings</a>
        </span>
      </a>
    </li>
    <hr />
  </ul>
</nav>